import React from "react";

import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Spacer from "../../../components/Spacer";
import ArticleCarousel from "../../Widgets/ArticleCarousel";

import style from "./style.module.css";

export default function SearchEmpty(props) {
    const {
        keyword,
        category,
        series,
        related_content,
    } = props;
    return (
        <div className={`${style.searchRelatedPost} searchRelatedPost`}>
            <div className={style.searchResultMessage}>
                <div className={`${style.searchMessageHeader} ${style.customSection}`}>
                    <div className={style.searchMessageHeaderRow}>
                        <Title tag="p">Your search for "{keyword !== "" ? <span>{keyword}</span> : ""}{category !== "" ? <span>{category}</span> : ""}{series !== "" ? <span>{series}</span> : ""}" did not have any matches.</Title>
                        <Spacer size="24" />
                        <Title tag="p">Suggestions:</Title>
                        <Spacer size="24" />
                        <Editor text="<ul><li>Try different keywords</li><li>Looking for additional resources?</li><li>Try education or feature categories</li><li>Trey using media type filter</li></ul>" />
                    </div>
                </div>
                {
                    related_content !== undefined &&
                    related_content.length > 0 && (
                        <div className={style.searchMessageBody}>
                            {
                                <ArticleCarousel
                                    title="related content"
                                    article={related_content}
                                />
                            }
                        </div>
                    )
                }
            </div>
        </div>
    )
}